import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function WorkPreviewSection() {
  const projects = [{
    title: 'FinTech Dashboard',
    category: 'Product Design',
    image: 'bg-gray-200' // Placeholder class
  }, {
    title: 'E-commerce Platform',
    category: 'Web Development',
    image: 'bg-gray-300' // Placeholder class
  }, {
    title: 'Health App',
    category: 'Mobile Design',
    image: 'bg-gray-400' // Placeholder class
  }];
  return <Section id="work" background="white" data-id="element-215">
      <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-216">
        <div data-id="element-217">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold font-heading text-[#0C0C0C] mb-4" data-id="element-218">
            Selected Work
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600 max-w-xl" data-id="element-219">
            A glimpse into the digital products, platforms, and experiences
            we've crafted.
          </motion.p>
        </div>
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-6 md:mt-0" data-id="element-220">
          <Button variant="outline" rightIcon={<ArrowRight size={16} data-id="element-222" />} data-id="element-221">
            View All Projects
          </Button>
        </motion.div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-223">
        {projects.map((project, index) => <motion.div key={project.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="group cursor-pointer" data-id="element-224">
            <div className={`aspect-[4/3] rounded-xl overflow-hidden mb-4 ${project.image} relative`} data-id="element-225">
              <div className="absolute inset-0 bg-[#0C0C0C]/0 group-hover:bg-[#0C0C0C]/5 transition-colors duration-300" data-id="element-226" />
              {/* Abstract placeholder visual since we don't have images */}
              <div className="w-full h-full flex items-center justify-center text-gray-400" data-id="element-227">
                <span className="sr-only" data-id="element-228">{project.title} Preview</span>
                <svg className="w-12 h-12 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-229">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-230" />
                </svg>
              </div>
            </div>
            <h3 className="text-xl font-bold font-heading text-[#0C0C0C] group-hover:text-[#00316B] transition-colors" data-id="element-231">
              {project.title}
            </h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-232">{project.category}</p>
          </motion.div>)}
      </div>
    </Section>;
}